import { render, staticRenderFns } from "./alkine.vue?vue&type=template&id=786c3251&"
import script from "./alkine.vue?vue&type=script&lang=js&"
export * from "./alkine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports